// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"Contact_contactContainer__243b4","contactItemsContainer":"Contact_contactItemsContainer__3rBUM","contactItem":"Contact_contactItem__3Je-x"};